<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Sound Files</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <h3>Upload</h3> <br>
        <form enctype="multipart/form-data">
          <div class="input-group mb-3">
            <div class="custom-file">
              <input type="file" class="custom-file-input" accept=".mp3,.wav" @change="processFile($event)">
              <label class="custom-file-label">{{ file_name }}</label>
            </div>
            <div class="input-group-append">
              <span class="input-group-text" @click="upload()">Upload</span>
            </div>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="cbAlert" v-model="tags.alert">
            <label class="form-check-label" for="cbAlert">Alert</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="cbAnnouncement" v-model="tags.announcement">
            <label class="form-check-label" for="cbAnnouncement">Announcement</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="cbBell" v-model="tags.bell">
            <label class="form-check-label" for="cbBell">Bell</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="cbPlaylist" v-model="tags.playlist">
            <label class="form-check-label" for="cbPlaylist">Playlist</label>
          </div>
        </form>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12 col-lg-4">
        <h3>Current Sound Files:</h3>
      </div>
      <div class="col-md-2 d-none d-lg-block"></div>
      <div class="col-md-6 d-none d-lg-block">
        <div class="row">
          <label class="col-2">Type:</label>
          <div class="col-8">
            <select class="form-control" v-model="selected_tag">
              <option value="all">Show All</option>
              <option value="alert">Alert</option>
              <option value="announcement">Announcement</option>
              <option value="bell">Bell</option>
              <option value="playlist">Playlist</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>File</th>
            <th>Tags</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="sound in filtered_sounds" :key="sound.sound_id">
            <td>
              <a-player narrow :music="{
                title: sound.filename,
                author: sound.filename,
                url: '/upload/sounds/' + sound.site_id + '/' + sound.filename,
                pic: './static/images/sound_file_image.png'
              }"></a-player>
              <span>{{ sound.filename }}</span>
            </td>
            <td>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbAlert' + sound.sound_id" v-model="sound.alert" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbAlert' + sound.sound_id">Alert</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbAnnouncement' + sound.sound_id" v-model="sound.announcement" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbAnnouncement' + sound.sound_id">Announcement</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbBell' + sound.sound_id" v-model="sound.bell" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbBell' + sound.sound_id">Bell</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" :id="'cbPlaylist' + sound.sound_id" v-model="sound.playlist" @change="setTags(sound)">
                <label class="form-check-label" :for="'cbPlaylist' + sound.sound_id">Playlist</label>
              </div>
            </td>
            <td>
              <button type="button" class="btn btn-danger" @click="deleteSound(sound)"><i
                class="fa fa-trash fa-fw" aria-hidden="true"></i></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueAplayer from '../vue-aplayer'
import 'aplayer/dist/APlayer.min.css'

export default {
  data: function () {
    return {
      file_name: '',
      file: '',
      tags: {
        alert: true,
        announcement: true,
        bell: true,
        playlist: true
      },
      selected_tag: 'all'
    }
  },
  computed: {
    ...mapGetters({
      sounds: 'allSounds',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_sounds: function () {
      return this.sounds.filter(sound => sound.site_id === this.scoped_site_id && (this.selected_tag === 'all' || sound.tags.includes(this.selected_tag)))
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getSounds')
  },
  components: {
    'a-player': VueAplayer
  },
  methods: {
    ...mapActions([
      'setTags'
    ]),
    processFile (event) {
      this.file_name = event.target.files[0].name
      this.file = event.target.files[0]
    },
    upload () {
      alert('Please be aware, it may take a few seconds to upload the file.')
      let data = {
        file: this.file,
        tags: this.tags
      }
      this.$store.dispatch('uploadSoundFile', data)
    },
    deleteSound (sound) {
      this.$store.dispatch('deleteSoundFile', sound)
    }
  }
}
</script>
